export const PAGE_TITLE = 'Aprovação de solicitações';
export const PAGE_SUBTITLE =
    'Férias e day-offs do seu time aguardando sua decisão.';

export const SEARCH_LABEL = 'Buscar por nome ou e-mail do colaborador';
export const SEARCH_PLACEHOLDER = 'Buscar por nome ou e-mail';

export const SORT_LABEL = 'Ordem das solicitações';

export const SORT_OPTIONS = [
    { value: 'newest', label: 'Mais recentes' },
    { value: 'oldest', label: 'Mais antigas' },
] as const;

export const EMPTY_SEARCH_MESSAGE =
    'Nenhuma solicitação corresponde à busca. Tente outro nome ou e-mail.';

export const EMPTY_ALL_DECIDED_MESSAGE =
    'Você respondeu todas as solicitações. As decisões ficam na lista abaixo.';

export const TOOLBAR_LABELS = {
    pending: (total: number) =>
        total === 1 ? 'solicitação aguardando sua decisão' : 'solicitações aguardando sua decisão',
    allDone: 'Nada aguardando você',
    allDoneHint: 'Todas as solicitações do seu time já foram respondidas.',
    oldest: (date: string) => `A mais antiga espera desde ${date}`,
} as const;

export const KIND_LABELS = {
    vacation: 'Férias',
    day_off: 'Day-off',
} as const;

export const TYPE_FILTER_OPTIONS = [
    { value: 'all', label: 'Todas' },
    { value: 'vacation', label: KIND_LABELS.vacation },
    { value: 'day_off', label: KIND_LABELS.day_off },
] as const;

export const TYPE_FILTER_LABEL = 'Tipo de solicitação';

export const DAY_OFF_CARD_LABELS = {
    title: 'Day-off de aniversário',
    date: 'Data',
    reason: 'Motivo',
    requestedAt: 'Solicitada em',
    expiresAt: 'Expira em',
    ariaLabel: (name: string) => `Solicitação de day-off de ${name}`,
} as const;

export const DAY_OFF_DECISION_COPY = {
    approve: {
        title: 'Aprovar day-off',
        description:
            'Ao aprovar, o DP é avisado para lançar a folga no ponto.\nO colaborador será notificado da aprovação.',
        noteLabel: 'Observação (opcional)',
        notePlaceholder: 'Ex.: folga alinhada com a squad.',
    },
    reject: {
        title: 'Reprovar day-off',
        description:
            'A reprovação encerra esta solicitação.\nO colaborador será notificado e verá o motivo.',
        noteLabel: 'Motivo da reprovação',
        notePlaceholder: 'Descreva o motivo da reprovação.',
    },
} as const;

export const DAY_OFF_DECIDED_LABELS = {
    title: 'Day-off de aniversário',
    decidedAt: 'Decidida em',
    note: 'Justificativa',
} as const;

export const ERROR_TITLES = {
    vacation: 'Não foi possível carregar as solicitações de férias',
    day_off: 'Não foi possível carregar os day-offs',
} as const;
